<template>
  <textarea
    @input="$emit('input', $event.target.value || null)"
    :value="value"
    class="textarea"
    :class="{'textarea--error': error}"
  >
  </textarea>
</template>

<script>
export default {
  name: 'AppTextarea',
  props: {
    error: Boolean,
    value: String,
  },
}
</script>

<style scoped lang="sass">
.textarea
  display: block
  width: 100%
  min-height: 90px
  padding: 12px 25px 11px 12px
  background-color: #fff
  border: 1px solid $color-border
  box-sizing: border-box
  border-radius: 7px
  font-family: $font-family-base
  font-size: 13px
  font-weight: 400
  line-height: 15.5px
  color: $color-text-base
  transition: border-color 0.3s
  resize: none
  scrollbar-color: $color-theme #f2f3f8
  scrollbar-width: thin

  &::-webkit-scrollbar
    width: 2px

  &::-webkit-scrollbar-track
    border-radius: 5px
    background-color: #f2f3f8

  &::-webkit-scrollbar-thumb
    border-radius: 5px
    background-color: $color-theme

  &::placeholder
    color: #5e5e5e

  &:focus
    border-color: #aaa

  &[readonly]
    border-color: #ff9416

.textarea--error
  border-color: $color-error

.textarea--400
  width: 400px

.textarea--mh-250
  min-height: 250px
</style>
